import type { AttendStatusType } from '@/types/domain/attendance/valueObjects/attendStatus';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * AttendStatus
 */
export class AttendStatus extends PrimitiveValueObject<AttendStatusType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: AttendStatusType): AttendStatus {
    return new AttendStatus(value);
  }

  /** ラベル */
  static get label(): string {
    return '出席状況';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'attendStatus';
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    return [{ id: '出席', name: '出席' }, { id: '欠席', name: '欠席' }];
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
